import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static r45(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.j45_1 = operation;
        $this.k45_1 = requestUuid;
        $this.l45_1 = data;
        $this.m45_1 = errors;
        $this.n45_1 = extensions;
        $this.o45_1 = exception;
        $this.p45_1 = Companion_getInstance().a44_1;
        $this.q45_1 = false;
        return $this;
      }
      static s45(operation, requestUuid) {
        return this.r45(operation, requestUuid, null, null, null, null);
      }
      t45(executionContext) {
        // Inline function 'kotlin.apply' call
        this.p45_1 = this.p45_1.u45(executionContext);
        return this;
      }
      v45(data) {
        // Inline function 'kotlin.apply' call
        this.l45_1 = data;
        return this;
      }
      w45(errors) {
        // Inline function 'kotlin.apply' call
        this.m45_1 = errors;
        return this;
      }
      x45(exception) {
        // Inline function 'kotlin.apply' call
        this.o45_1 = exception;
        return this;
      }
      q44(extensions) {
        // Inline function 'kotlin.apply' call
        this.n45_1 = extensions;
        return this;
      }
      b44(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.k45_1 = requestUuid;
        return this;
      }
      y45(isLast) {
        // Inline function 'kotlin.apply' call
        this.q45_1 = isLast;
        return this;
      }
      l38() {
        var tmp1_operation = this.j45_1;
        var tmp2_requestUuid = this.k45_1;
        var tmp3_data = this.l45_1;
        var tmp4_executionContext = this.p45_1;
        var tmp0_elvis_lhs = this.n45_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.m45_1;
        var tmp7_exception = this.o45_1;
        var tmp8_isLast = this.q45_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.z45_1 = requestUuid;
        this.a46_1 = operation;
        this.b46_1 = data;
        this.c46_1 = errors;
        this.d46_1 = exception;
        this.e46_1 = extensions;
        this.f46_1 = executionContext;
        this.g46_1 = isLast;
      }
      h46() {
        var tmp;
        if (this.v46()) {
          throw ApolloGraphQLException().u46(first(ensureNotNull(this.c46_1)));
        } else if (!(this.d46_1 == null)) {
          throw DefaultApolloException().n46('An exception happened', this.d46_1);
        } else {
          tmp = this.i46();
        }
        return tmp;
      }
      i46() {
        var tmp0_elvis_lhs = this.b46_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().a47(this.d46_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v46() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.c46_1;
        return !(this_0 == null || this_0.n1());
      }
      h45() {
        return Builder().r45(this.a46_1, this.z45_1, this.b46_1, this.c46_1, this.e46_1, this.d46_1).t45(this.f46_1).y45(this.g46_1);
      }
      toString() {
        var tmp = 'operationName=' + this.a46_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.b46_1 == null ? 'null' : this.a46_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.c46_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.d46_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.d46_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
